<div class="row" *ngIf="currentOrganization$ | async as currentOrganization">
  <div class="col-12 col-lg-10 order-2 order-lg-1">
    <h1>Översikt</h1>

    <div
      class="text-warning alert alert-light border border-warning border-dashed d-flex flex-column flex-lg-row align-items-center p-2"
      *ngIf="!currentOrganization.logoUrl">
      <small class="flex-fill">
        <span class="material-icons align-middle me-2">warning</span
        ><span class="align-middle">Organisationen saknar logotyp.</span>
      </small>
      <button
        class="btn btn-sm btn-success m-0 ms-2 mt-2 mt-lg-0"
        [routerLink]="['/organization', currentOrganization.id, 'settings']">
        Gå till inställningar
      </button>
    </div>

    <div
      class="text-warning alert alert-light border border-warning border-dashed d-flex flex-column flex-lg-row align-items-center p-2"
      *ngIf="
        currentOrganization.logoUrl &&
        (!currentOrganization.logoSize || currentOrganization.logoSize.width < 400 || currentOrganization.logoSize.height < 400)
      ">
      <small class="flex-fill">
        <span class="material-icons align-middle me-2">warning</span
        ><span class="align-middle">Organisationens logotyp är för liten! Storleken måste vara minst 400 x 400 pixlar</span>
      </small>
      <button
        class="btn btn-sm btn-success m-0 ms-2 mt-2 mt-lg-0"
        [routerLink]="['/organization', currentOrganization.id, 'settings']">
        Gå till inställningar
      </button>
    </div>

    <div
      class="text-warning alert alert-light border border-warning border-dashed d-flex flex-column flex-lg-row align-items-center p-2"
      *ngIf="
        !currentOrganization.organizationNumber ||
        currentOrganization.organizationNumber.length === 0 ||
        !currentOrganization.streetAddress ||
        currentOrganization.streetAddress.length === 0 ||
        !currentOrganization.zipCode ||
        currentOrganization.zipCode.length === 0 ||
        !currentOrganization.city ||
        currentOrganization.city.length === 0
      ">
      <small class="flex-fill">
        <span class="material-icons align-middle me-2">warning</span
        ><span class="align-middle"
          >Det saknas vissa uppgifter på organisationen för att alla funktioner ska fungera korrekt. Se över
          inställningarna!</span
        >
      </small>
      <button
        class="btn btn-sm btn-success m-0 ms-2 mt-2 mt-lg-0"
        [routerLink]="['/organization', currentOrganization.id, 'settings']">
        Gå till inställningar
      </button>
    </div>

    <div
      *ngIf="!currentOrganization.isSupervisor && !currentOrganization.lastMemberRegistryUpdate"
      class="alert alert-light border border-warning mb-4 pb-3 pb-lg-4">
      <h3><span class="material-icons align-middle me-2">group</span><span class="align-middle">Personer saknas</span></h3>
      Första gången du använder klubbavgift behöver du importera ert medlemsregister eller lista över personer. Oroa dig inte, det
      är inte så komplicerat! Vi har i nuläget stöd för IdrottOnline, Laget.se samt en generell excelfil man kan administrera
      själv. När du väl har gjort det en gång kommer det gå mycket snabbare nästa gång då registret ibland behöver uppdateras
      beroende på hur ofta och mycket det förändras.<br />
      Mer information hittar du under knappen 'Importera' i menyn
      <a routerLink="members">Personer</a>.
      <button class="btn btn-outline-primary float-none d-block float-lg-end mt-2 mt-lg-0" (click)="postponeImportReminder()">
        <span class="material-icons">check</span><span>Jag förstår</span>
      </button>
    </div>
    <div
      *ngIf="currentOrganization.lastMemberRegistryUpdate && currentOrganization.suggestMemberRegistryImport"
      class="alert alert-light border border-info mb-4 pb-3 pb-lg-4">
      <h3>
        <span class="material-icons align-middle me-2">group</span
        ><span class="align-middle">Dags att uppdatera organisationens register?</span>
      </h3>
      Nu är det över tre månader sedan ni uppdaterade registret över personer. Ni kan självklart fortsätta använda klubbavgift
      ändå, men risken finns att det är personer som saknas eller har felaktiga uppgifter som missar information alternativt
      personer som slutat. Det är rekommenderat att med jämna mellanrum göra en ny import av denna lista. Inom en snar framtid
      hoppas vi ha en automatiserad lösning på plats där man helt slipper detta steg. För idrottsföreningar väntar vi just nu på
      Riksidrottsförbundet som eventuellt har en lösning för alla dessa.<br />
      Vill du uppdatera registret så gör du det via knappen 'Importera' i menyn
      <a routerLink="members">Personer</a>.
      <button class="btn btn-outline-primary float-none d-block float-lg-end mt-2 mt-lg-0" (click)="postponeImportReminder()">
        <span class="material-icons">snooze</span><span>Påminn senare</span>
      </button>
    </div>
    <div class="mb-4" *ngIf="currentOrganization.administratorRequests && currentOrganization.administratorRequests.length > 0">
      <h3>
        Godkänn nya administratörer<small class="d-block text-smaller"
          >Nedanstående personer har ansökt om att vara administratörer för {{ currentOrganization.name }}</small
        >
      </h3>
      <div class="row">
        <div class="col-sm-3" *ngFor="let user of currentOrganization.administratorRequests">
          <div class="card">
            <div class="card-body">
              <div>
                <h5 class="card-title">{{ user.name }}</h5>
              </div>
              <div class="d-flex">
                <img [src]="user.profileImageUrl" class="me-2" alt="{{ user.name }}'s profilbild" />
                <div>
                  <small class="d-block text-muted">{{ user.email }}</small>
                  <small class="d-block text-muted" *ngIf="user.lastIdentityProvider"
                    >Använder <span *ngIf="user.lastIdentityProvider === 'facebook.com'">Facebook-konto</span>
                    <span *ngIf="user.lastIdentityProvider === 'google.com'">Google-konto</span>
                    <span *ngIf="user.lastIdentityProvider === 'linkedin'">LinkedIn-konto</span>
                    <span *ngIf="user.lastIdentityProvider === 'microsoft.com'">Microsoft-konto</span></small
                  >
                </div>
              </div>
              <div class="card-text py-2"></div>
              <button
                class="btn btn-success me-2 px-3"
                [disabled]="isHandlingAdminRequest$ | async"
                (click)="handleAdministratorRequest(user, true)">
                Godkänn
              </button>
              <button
                class="btn btn-danger px-3"
                [disabled]="isHandlingAdminRequest$ | async"
                (click)="handleAdministratorRequest(user, false)">
                Neka
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-current-activities [showButtons]="false"></app-current-activities>
    <ng-container
      *ngIf="
        currentOrganization.childOrganizations &&
        currentOrganization.childOrganizations.length > 0 &&
        (isLoadingActivities$ | async) === false
      ">
      <div class="mb-5" *ngFor="let child of currentOrganization.childOrganizations">
        <div>
          <div class="d-flex">
            <img [src]="child.logoUrl" style="height: 50px" alt="{{ child.name }}'s logo" />
            <div
              class="d-flex flex-column justify-content-center"
              [ngClass]="{ 'ms-2': child.logoUrl && child.logoUrl.length > 0 }">
              <h4 class="mb-0">{{ child.name }}'s aktiviteter</h4>
              <div>
                <span class="d-inline" *ngIf="child.administrators.length > 0">
                  <small *ngFor="let administrator of child.administrators; let i = index">
                    {{ administrator.name }}<span *ngIf="i < child.administrators.length - 1">, </span>
                  </small>
                </span>
                <span
                  class="d-inline badge rounded-pill bg-primary"
                  [ngClass]="{ 'ms-2': child.administrators.length > 0 }"
                  *ngIf="child.administratorRequests.length > 0">
                  <span *ngIf="child.administrators.length > 0">+ </span>Väntande administratörsförfrågningar
                </span>
              </div>
            </div>
          </div>
          <div class="mt-3 row">
            <span class="text-muted fst-italic" *ngIf="!child.activities || child.activities.length === 0"
              >Organisationen har inga pågående aktiviteter</span
            >
            <div class="col-sm-6 col-lg-4 mb-3 align-self-stretch" *ngFor="let activity of child.activities">
              <app-activity-item-card [organization]="child" [activity]="activity"></app-activity-item-card>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="col-12 col-lg-2 order-1 order-lg-2 mb-4 mb-2 mb-lg-0">
    <button
      class="btn btn-primary w-100"
      [routerLink]="['/organization', currentOrganization.id, 'activities', 'create']"
      [queryParams]="{ type: currentOrganization.isSupervisor ? 'template' : '' }">
      <span class="material-icons">add</span>
      <span *ngIf="!currentOrganization.isSupervisor">Ny aktivitet</span>
      <span *ngIf="currentOrganization.isSupervisor">Ny aktivitetsmall</span>
    </button>
    <button
      class="btn btn-primary w-100 mt-2"
      *ngIf="currentOrganization.isSupervisor"
      [routerLink]="['/organization', 'register']"
      [queryParams]="{ parent: currentOrganization.id }">
      <span class="material-icons">add</span>
      <span>Ny underorganisation</span>
    </button>
    <ng-container *ngIf="(showHiddenAdminFeatures$ | async) && !isProduction">
      <form #form>
        <input
          #fileSelector
          class="form-control"
          type="file"
          id="file"
          style="display: none"
          accept=".zip"
          (change)="importActivity($event)" />
        <button
          type="button"
          class="btn btn-outline-primary d-block w-100 mt-2"
          [disabled]="isExportingOrImporting$ | async"
          (click)="fileSelector.value = ''; fileSelector.click()">
          <ng-container *ngIf="isExportingOrImporting$ | async as isExportingOrImporting; else notExportingOrImporting">
            <span class="material-icons spin">sync</span>
          </ng-container>
          <ng-template #notExportingOrImporting>
            <span class="material-icons">file_download</span>
          </ng-template>

          <span>Importera</span>
        </button>
      </form>
    </ng-container>
    <button class="btn btn-outline-primary w-100 mt-2" [routerLink]="['/organization', currentOrganization.id, 'payment-search']">
      <span class="material-icons-outlined">search</span><span>Sök betalning</span>
    </button>
  </div>
</div>
